import React, { Suspense } from 'react';
import { Body } from './ui';

export const NonMember = () => {
  return (
    <Suspense>
      <Body />
    </Suspense>
  );
};
